"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var TooltipErrorBoundry = /*#__PURE__*/function (_React$Component) {
  function TooltipErrorBoundry(props) {
    return _React$Component.call(this, props) || this;
  }
  (0, _inheritsLoose2.default)(TooltipErrorBoundry, _React$Component);
  var _proto = TooltipErrorBoundry.prototype;
  _proto.componentDidCatch = function componentDidCatch(error, info) {
    console.error('Error while rendering tooltip. Please refer tooltip documentation for more details. https://path-designsystem.elluciancloud.com/#/components/Tooltip');
    console.error('Error details:', error);
    console.error('Info:', info);
  };
  _proto.render = function render() {
    return this.props.children;
  };
  return TooltipErrorBoundry;
}(_react.default.Component);
TooltipErrorBoundry.propTypes = {
  /**
   * Tooltip reference element.
   */
  children: _propTypes.default.element
};
var _default = exports.default = TooltipErrorBoundry;